const emptyOptionValue = '__empty__'

const optionValue = (value) => value === '' ? emptyOptionValue : String(value)

const realValue = (value) => value === emptyOptionValue ? '' : value

const parseVehicles = (root) => {
    try {
        return JSON.parse(root.dataset.vehicles || '[]')
    } catch (error) {
        return []
    }
}

const uniqueValues = (items, key, keepEmpty = false) => {
    return items
        .map((item) => item[key] || '')
        .filter((value, index, list) => {
            return (keepEmpty || value !== '') && list.indexOf(value) === index
        })
        .sort()
}

const fillSelect = (select, values, selected = '', emptyLabel = 'Sem versão') => {
    select.innerHTML = '<option value="">Selecione</option>'

    values.forEach((value) => {
        const option = document.createElement('option')
        option.value = optionValue(value)
        option.textContent = value === '' ? emptyLabel : value
        option.selected = String(selected || '') === optionValue(value)
        select.appendChild(option)
    })

    select.disabled = values.length === 0
}

const initVehicleSearch = (root) => {
    if (!root || root.dataset.initialized === 'true') {
        return
    }

    const vehicles = parseVehicles(root)
    const brandSelect = root.querySelector('[data-vehicle-brand]')
    const modelSelect = root.querySelector('[data-vehicle-model]')
    const yearSelect = root.querySelector('[data-vehicle-year]')
    const versionSelect = root.querySelector('[data-vehicle-version]')
    const vehicleIdInput = root.querySelector('[data-vehicle-id]')

    if (!vehicles.length || !brandSelect || !modelSelect || !yearSelect || !versionSelect || !vehicleIdInput) {
        return
    }

    root.dataset.initialized = 'true'

    const selectedVehicleId = root.dataset.selectedVehicle || ''
    const form = root.querySelector('form') || root.closest('form')
    const variant = root.dataset.variant

    const selectedVehicle = () => {
        return vehicles.find((vehicle) => {
            return String(vehicle.brand) === String(brandSelect.value) &&
                String(vehicle.model) === String(modelSelect.value) &&
                String(vehicle.year) === String(yearSelect.value) &&
                String(vehicle.version || '') === String(realValue(versionSelect.value || ''))
        })
    }

    const updateVehicleId = () => {
        const vehicle = selectedVehicle()
        vehicleIdInput.value = vehicle ? vehicle.id : ''
    }

    const updateVersions = (selected = '') => {
        const items = vehicles.filter((vehicle) => {
            return vehicle.brand === brandSelect.value &&
                vehicle.model === modelSelect.value &&
                String(vehicle.year) === String(yearSelect.value)
        })

        fillSelect(versionSelect, uniqueValues(items, 'version', true), selected, 'Sem versão')
        versionSelect.value = selected ? optionValue(selected) : ''
        updateVehicleId()
    }

    const updateYears = (selected = '') => {
        const items = vehicles.filter((vehicle) => {
            return vehicle.brand === brandSelect.value && vehicle.model === modelSelect.value
        })

        fillSelect(yearSelect, uniqueValues(items, 'year'), selected)
        yearSelect.value = selected ? optionValue(selected) : ''
        updateVersions()
    }

    const updateModels = (selected = '') => {
        const items = vehicles.filter((vehicle) => vehicle.brand === brandSelect.value)

        fillSelect(modelSelect, uniqueValues(items, 'model'), selected)
        modelSelect.value = selected ? optionValue(selected) : ''
        updateYears()
    }

    brandSelect.addEventListener('change', () => updateModels())
    modelSelect.addEventListener('change', () => updateYears())
    yearSelect.addEventListener('change', () => updateVersions())
    versionSelect.addEventListener('change', updateVehicleId)

    if (variant === 'home' && form) {
        form.addEventListener('submit', (event) => {
            updateVehicleId()
            if (!vehicleIdInput.value) {
                event.preventDefault()
            }
        })
    }

    fillSelect(brandSelect, uniqueValues(vehicles, 'brand'))

    if (!selectedVehicleId) {
        return
    }

    const selected = vehicles.find((vehicle) => String(vehicle.id) === String(selectedVehicleId))
    if (!selected) {
        return
    }

    brandSelect.value = selected.brand
    updateModels(selected.model)
    updateYears(selected.year)
    updateVersions(selected.version || '')
    vehicleIdInput.value = selected.id
}

export const initVehicleSearches = () => {
    document.querySelectorAll('[data-vehicles]').forEach(initVehicleSearch)
}

export const installVehicleSearch = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVehicleSearches)
        return
    }

    initVehicleSearches()
}
